import { useQuery } from '@tanstack/react-query';

import { queryKeys } from 'api/config';
import { useQueryHTTPRequest } from 'shared_DEPRECATED/hooks';

export const useCoachTimezonesQuery = () => {
  const { request } = useQueryHTTPRequest();

  return useQuery(
    [queryKeys.coachingTimezones],
    ({ signal }) => request({ url: '/api/timezones', signal }),
    {
      initialData: { timezones: [] },
      select: (data) => data.timezones,
    }
  );
};
